import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useLogin from "../../services/hooks/useLogin";
import usePost from "../../services/usePost";
import useCustomSnackbar from "../../helper/useCustomSnackbar";

const ForgotPassword = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [isLoading, error, handleForgotPassword] = useLogin("auth/forgot-password");
  const showSnackbar = useCustomSnackbar();


  const [postLoading, errorMsg, postData] = usePost();

  const handleRedirectLogin = () => {
    navigate('/')
  }
  const onFinish = async (values) => {
    // setIsLoggedIn(true);
    // navigate("/");
    // console.log("Success:", values);

    // try {
    //   await handleForgotPassword(values)
    // } catch (error) {
    //   setLoginError(error.message);
    // } finally {
    //   setLoading(false);
    // }
    // console.log(values,'.......')

    const dataToSend = {
      email: values.email,
      redirectURL: "https://userpanel.taggeo.net/reset-password"
    }
    
    try{
      const response = await postData('auth/forgot-password',dataToSend,true,false)

      if(response?.error){
        // console.log(response,'.....')
        showSnackbar('error','User not found')
      }
      else{
        showSnackbar('success','Password reset link has been sent to your email')
      }
    }
    catch(err){
      console.log(err)
    }

  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      <Col md={12}>
        <div className="forgetPass"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <h3>Forgot your Password ?</h3>

          <hr className="my-4" />
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Please input your Email!" }]}
          >
            <Input className="input_field" placeholder="Email" />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Reset
            </Button>
          </Form.Item>
          <Form.Item>
            <Flex justify="center" align="center">
              <p onClick={handleRedirectLogin} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>Back to Login</p>
            </Flex>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
